import React from 'react';

const Senderismo = () => {
  return (
    <div className="container mt-5 pt-3">
      {/* Section 1: Bootstrap Carousel */}
      <div id="senderismoCarousel" className="carousel slide mb-5" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#senderismoCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#senderismoCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#senderismoCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
        </div>
        
        <div className="carousel-inner rounded shadow">
          
        </div>
        
        <button className="carousel-control-prev" type="button" data-bs-target="#senderismoCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#senderismoCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      
      {/* Section 2: Title and Description */}
      <div className="row">
        <div className="col-12 text-center">
          <h1 className="display-4 text-success mb-3">Senderismo</h1>
          <p className="lead mb-5 text-start">Cada paso en los senderos está diseñado para fomentar una conexión profunda con el entorno natural, ayudando a reducir el estrés y promoviendo el bienestar físico y mental. Promovemos el respeto por el medio ambiente, animando a los excursionistas a cuidar de los senderos y preservar la belleza de la naturaleza circundante.
          <br/>Para aquellos que buscan una experiencia más enriquecedora, Casa Origen Ecohotel ofrece guías locales que conocen la flora y fauna de la región. Ellos pueden compartir historias y conocimientos sobre el entorno, haciendo del senderismo una experiencia educativa y culturalmente enriquecedora.</p>
        </div>
      </div>
    </div>
  );
};

export default Senderismo;